import React from "react";
import {Grid, Stack} from "@mui/material";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import VideoPicker from "../common/VideoPicker";
import CellImage from "../common/CellImage";


const Uploader = ({videos, multiple = false, size = 60, onUploaded, ...props}) => {
  function handleUpload() {
    VideoPicker({
      multiple,
      onSelect(video) {
        let _videos = video;
        if (multiple) {
          _videos = videos ? `${videos},${video}` : video;
        }
        //console.log('==========> Video selected : %o', _videos)
        onUploaded(_videos);
      },
    });
  }

  function handleDelete(idx) {
    console.log('==========> Video delete : %o, videos : %o', idx, videos)
    const vids = videos.split(",");
    vids.splice(idx, 1);
    onUploaded(vids.join(","));
  }

  if (!multiple) {
    return (
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{
          position: 'relative',
          width: size,
          height: size,
          cursor: "pointer",
          borderRadius: "4px",
          border: "1px dotted rgba(0,0,0,.1)",
          backgroundColor: "rgba(0,0,0,.02)",
        }}
        onClick={() => {
          // if (videoObj&&videoObj.length>0) {
          //   return;
          // }
          handleUpload()
        }}
      >
        {videos ?
          <Stack alignItems="center" sx={{mt: 1}}>
            <p style={{fontSize: '12px', margin: 0}}>更新</p>
            <p style={{fontSize: '12px', margin: 0}}>视频</p>
          </Stack>
          : <InsertPhotoIcon sx={{color: "#aaa"}}/>}
        <div className="rcc" style={{
          position: "absolute",
          right: -10,
          top: -10,
          backgroundColor: "rgba(255, 255, 255, 1)",
          borderRadius: "50%",
          cursor: "pointer"
        }} onClick={() => handleDelete(0)}>
          <RemoveCircleOutlineIcon/>
        </div>
      </Stack>
    );
  }

  return (
    <Stack direction="row" alignItems="flex-start" {...props}>
      <Grid columns={5} container columnSpacing={2}>
        {!videos
          ? null
          : videos.split(",").map((img, i) => (
            <Grid item key={i} sx={{position: "relative"}}>
              {videos ? <>
                  <CellImage preview src={`${videos}`} style={{width: "100%", height: "100%", borderRadius: 4}}/>
                  <Stack alignItems="center" sx={{mt: 1}}>
                    <p style={{fontSize: '14px', margin: 0}}>更新</p>
                    <p style={{fontSize: '14px', margin: 0}}>视频</p>
                  </Stack>
                </>
                : <InsertPhotoIcon sx={{color: "#aaa"}}/>}

              <div className="rcc" style={{
                position: "absolute",
                right: -10,
                top: -10,
                backgroundColor: "rgba(255, 255, 255, 1)",
                borderRadius: "50%",
                cursor: "pointer"
              }} onClick={() => handleDelete(i)}>
                <RemoveCircleOutlineIcon/>
              </div>
            </Grid>
          ))}

        <Grid item>
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
              width: 60,
              height: 60,
              flexShrink: 0,
              cursor: "pointer",
              borderRadius: "4px",
              border: "1px dotted rgba(0,0,0,.1)",
              backgroundColor: "rgba(0,0,0,.02)",
            }}
            onClick={handleUpload}
          >
            <InsertPhotoIcon sx={{color: "#aaa"}}/>
          </Stack>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default Uploader;
